"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinBalanceUSD = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const decimal_js_1 = __importDefault(require("decimal.js"));
const react_1 = require("react");
const utils_1 = require("src/misc/utils");
const CoinBalanceUSD = (props) => {
    const { tokenInfo, amount, maxDecimals, prefix = '' } = props;
    const tokenPrice = tokenInfo.usdPrice || 0;
    const amountInUSD = (0, react_1.useMemo)(() => {
        if (!amount || !(0, utils_1.hasNumericValue)(amount))
            return new decimal_js_1.default(0);
        return new decimal_js_1.default(amount).mul(tokenPrice);
    }, [amount, tokenPrice]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [prefix, "$", utils_1.formatNumber.format(amountInUSD, maxDecimals || 2)] }));
};
exports.CoinBalanceUSD = CoinBalanceUSD;
